<template>
  <div :class="item.styles">
    <div :class="['r-card w-100 h-100 position-relative card-background']" :style="{ 'background-image': `url(${ $store.state.window > 1100 ? item.icon : item.smallIcon })`}">
      <Loader v-if="!display" />
      <Error v-if="error" />
      <div v-if="display && !error" class="black-gradient-1 inner filter-blur-4 cont flex-start-center">
        <div class="w-100" :class="[lang === 'ar' ? 'arDir' : '']">
          <div :class="[lang === 'ar' ? 'text-right bold-ar' : 'bold-en' ,'card-title p-0']">
            {{item.title}}
          </div>
          <div :class="[lang === 'ar' ? 'text-right' : '' ,'white-description']">
            {{item.description}}
          </div>
          <div :class="[lang === 'ar' ? 'text-right' : '' ,'mt-4']">
            <div :class="[lang === 'ar' ? 'flex-row-reverse float-right' : '', 'd-flex small-container']">
              <a class="d-flex" :class="[lang === 'ar' ? 'arDir' : '']" :href="item.link" target="_blank">
                <div :class="[lang === 'ar' ? 'ml-2' : 'mr-2' ,'read-text']">
                  <span :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'read-text']">{{$t('readMore')}}</span>
                </div>
                <div>
                  <img :class="[this.$lang === 'ar' ? 'rotate' : '','read-arrow']" src="../../assets/icons/readmore.svg">
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import Loader from '../LoaderBtn/Loader'
import Error from '../errorHandle/Error'
export default {
  name: 'RandomCard',
  components: { Loader, Error },
  props: {
    data: {
      type: Object
    },
    show: Boolean,
    error: Boolean
  },
  data () {
    return {
      item: { title: '', description: '', icon: '', styles: '' },
      lang: this.$lang,
      display: this.show
    }
  },
  watch: {
    show (val) {
      this.item = this.data
      this.display = val
    },
    error (val) {
      if (val) {
        this.display = true
      }
    }
  },
  created () {
    this.item = this.data
  },
  mounted () {
    if (!this.show && this.error) {
      this.display = true
    }
    setTimeout(() => {
      this.$lang === 'ar' ? $('.read-text').css('font-family', 'Mtn-arabic-bold') : $('.read-text').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.card-title').css('font-family', 'Mtn-arabic-bold') : $('.card-title').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.white-description').css('font-family', 'Mtn-arabic-regular') : $('.white-description').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('#random_cards .row.row-padding').css('flex-direction', 'row-reverse') : $('#random_cards .row.row-padding').css('flex-direction', 'row')
      this.$lang === 'ar' ? $('.read-arrow').css('transform', 'rotate(180deg)') : $('.read-arrow').css('transform', 'rotate(0deg)')
    })
  }
}
</script>

<style scoped>
.r-card {
  background-position-x: center;
  background-position-y: center;
  background-repeat-x: no-repeat;
  background-repeat-y: no-repeat;
}
.small-container{
  width: max-content;
}
.arDir{
  direction: rtl !important;
}
.rotate{
  transform: rotate(180deg);
}
</style>
